import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	position: relative;
	flex-direction: column;
	border-radius: 0.9375rem;
`;
